import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useUpdateImportedMeetingTypes(onDone = () => {}) {
  const mutationFactory = useCallback(() => {
    const query = `mutation updateSyncedMeetingTypes($typeIds: [String]!) {
        updateSyncedMeetingTypes(typeIds: $typeIds) {
            importedMeetingTypes
        }
      }
    `;

    const resolver = (resp) => {
      return resp;
    };

    return { query, resolver };
  }, []);

  const [mutate, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone: useCallback(onDone, []),
  });

  return {
    update: (importedTypeIds) => {
      mutate(
        { typeIds: importedTypeIds },
        {
          successMsg:
            "The Imported Meeting Types have been successfully updated",
          defaultErrorMsg:
            "Failed to update the Imported Meeting Types, please try again or contact support for assistance.",
        }
      );
    },
    loading: loading,
  };
}

export default useUpdateImportedMeetingTypes;
